import mintArray from "../mintArray.json";
import abi from "../comicABI.json";
import Web3 from "web3";
const { ethereum } = window;
const web3 = new Web3(ethereum);

const address = "0x3673d02A78a266432f29f80DE511B76957E32a12";
const chainID = 1;
let network;

const Comic_randomFunc = async (number) => {
  const length = [];
  if (window.ethereum) {
    const contract = new web3.eth.Contract(abi, address);
    for (let i = 0; i < number; i++) {
      const geNumber = async () => {
        var random = Math.floor(Math.random() * 1000) + 1;
        await web3.eth.net.getId().then(async (netId) => {
          if (netId != chainID) {
          } else {
            try {
              const token = await contract.methods.ownerOf(random).call();
              geNumber();
            } catch (error) {
              const minted = await contract.methods.getMinted().call();
              const condition = minted.includes(number);
              if (!condition) {
                length.push(random);
                console.log(length);

                // if (length.length.toFixed() === number.toFixed()) {
                //   console.log("same");
                //   return;
                // } else {
                //   geNumber();
                // }
              } else {
                geNumber();
              }
            }
          }
        });
      };
      await geNumber();
    }
    return length;
  }
};

export const MintComic = async (number) => {
  if (number === "" || number === 0) {
    return {
      success: false,
      status: "❗Please make sure all fields are completed before minting.",
    };
  }
  if (window.ethereum) {
    const contract = new web3.eth.Contract(abi, address);
    const supply = await contract.methods.totalMinted().call();
    const accounts = await web3.eth.getAccounts();
    let price = 0;
    if (mintArray.includes(accounts[0])) {
      const tokens = await contract.methods.walletOfOwner(accounts[0]).call();
      if (tokens.length === 0) {
        price = 0;
      } else if (supply >= 300) {
        price = 1;
      } else if (supply < 300) {
        price = 0.5;
      }
    } else if (supply < 300) {
      price = 0.5;
    }
    try {
      const tokens = await Comic_randomFunc(number);

      let totalCostWei = web3.utils.toWei(`${price}`, "ether") * tokens.length;
      await contract.methods.mint(tokens).send({
        from: accounts[0],
        to: address,
        value: totalCostWei.toString(),
      });
    } catch (error) {}
  }
};

export const totalSupply = async () => {
  if (window.ethereum) {
    const contract = new web3.eth.Contract(abi, address);
    try {
      const supply = await contract.methods.totalMinted().call();
      console.log(supply);
      return supply;
    } catch (error) {
      return {
        success: false,
        status: "😥 Something went wrong: " + error.message,
      };
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};

export const walletOwner = async () => {
  if (window.ethereum) {
    const contract = new web3.eth.Contract(abi, address);
    const contract2 = new web3.eth.Contract(abi, address);
    const accounts = await web3.eth.getAccounts();

    try {
      const token = await contract.methods.walletOfOwner(accounts[0]).call();
      return token;
    } catch (error) {
      return {
        success: false,
        status: "😥 Something went wrong: " + error.message,
      };
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};
